import Swiper from 'swiper/bundle';
import "swiper/swiper-bundle.css";


window.addEventListener("load", () => {
  const animalsSlider = document.querySelectorAll('.animals-slider');
  if(animalsSlider.length <= 0) return;

  animalsSlider.forEach(slider => {
    const hoverElemnts = slider.querySelectorAll('.element');
    const elements = slider.querySelectorAll('[data-hover-items]');
    const sectionThird = slider.querySelector('.animals-slider__third');
    const animals = slider.querySelector('#_animals');

    const swiper_second = new Swiper(slider.querySelector('.animals-slider__outer'), {
      slidesPerView: 1,
      spaceBetween: 10,
      autoHeight: true,
    });

    // eslint-disable-next-line no-unused-vars
    const gallery = new Swiper(slider.querySelector('.gallery', {
      spaceBetween: 10,
      slidesPerView: 1,
    }));

    hoverElemnts.length > 0 && hoverElemnts.forEach((element) => {
      element.addEventListener('mouseenter', () => {
        const hoverItems = element.dataset.hoverItems ? element.dataset.hoverItems.split(" ").filter(item => item !== "") : [];
        hoverItems.length > 0 && hoverItems.forEach((item) => elements.forEach(el => el.dataset.hoverItems.includes(`${item} `) && !el.classList.contains('hover-items') && el.classList.add('hover-items')));
      });

      element.addEventListener('mouseleave', () => elements.forEach(el => el.classList.remove('hover-items')));
    });

    let initializedSliders = [];

    sectionThird && sectionThird.addEventListener('click', (e) => {
      if (e.target.classList.contains('animals-slider__package-btn') && !e.target.classList.contains('active')) {
        const tab = e.target.closest('.animals-slider__tab-wrap');

        const activeButton = tab.querySelector('.animals-slider__package-btn.active');
        if (activeButton) {
          activeButton.classList.remove('active');
        }

        const activeImage = tab.querySelector('.animals-slider__tab-img.active');
        if (activeImage) {
          activeImage.classList.remove('active');
        }
        e.target.classList.add('active');
        const currentTab = tab.querySelector(`[data-img="${e.target.dataset.title}"]`);
        currentTab.classList.add('active');

        const swiperElement = currentTab.querySelector('.swiper');

        if (swiperElement && !initializedSliders.some(slider => slider === swiperElement)) {
          initializedSliders.push(swiperElement);
          const swiper = new Swiper(swiperElement, {
            pagination: {
              el: swiperElement.querySelector(".swiper-pagination"),
              clickable: true,
            },
            speed: 800,
            autoplay: {
              delay: 3000,
              disableOnInteraction: true,
            },
            breakpoints: {
              768: {
                autoHeight: false,
              },
            },
          });

          swiperElement.addEventListener('mouseenter', () => {
            swiper.autoplay.stop();
          });

          swiperElement.addEventListener('mouseleave', () => {
            swiper.autoplay.start();
          });
        }
      }
    });

    slider.querySelectorAll('.animals-slider__tab-wrap').forEach(tabWrap => {
      const firstTabImg = tabWrap.querySelector('.animals-slider__tab-img');
      const firstSwiper = tabWrap.querySelector(".animals-slider__tab-media .swiper");

      if (firstTabImg) {
        firstTabImg.classList.add('active');
      }

      const firstPackageBtn = tabWrap.querySelector('.animals-slider__package-btn');
      if (firstPackageBtn) {
        firstPackageBtn.classList.add('active');
      }

      if (firstSwiper && !initializedSliders.some(slider => slider === firstSwiper)) {
        initializedSliders.push(firstSwiper);
        const swiper = new Swiper(firstSwiper, {
          pagination: {
            el: firstSwiper.querySelector(".swiper-pagination"),
            clickable: true,
          },
          speed: 800,
          autoplay: {
            delay: 3000,
            disableOnInteraction: true,
          },
          breakpoints: {
            768: {
              autoHeight: false,
            },
          },
        });

        firstSwiper.addEventListener('mouseenter', () => {
          swiper.autoplay.stop();
        });

        firstSwiper.addEventListener('mouseleave', () => {
          swiper.autoplay.start();
        });
      }
    });



    let clickedBtn = document.querySelector('#_animals button.swiper-pagination-bullet-active');

    animals.addEventListener('click', (e) => {
      let button = e.target.closest('button');
      if (button) {
        const currentAnimal = button.dataset.animal;

        initializedSliders.forEach(swiperElement => {
          if (swiperElement.swiper) {
            swiperElement.swiper.slideTo(0, 0);
            if (swiperElement.swiper.autoplay) {
              swiperElement.swiper.autoplay.start();
            }
          }
        });

        if (clickedBtn && clickedBtn !== button) {
          clickedBtn.classList.remove('swiper-pagination-bullet-active');
        }

        const secondSlider = document.querySelectorAll('.animals-slider__second .animals-slider__section');
        const indexSlide = Array.from(secondSlider).findIndex(e => e.dataset.animalSection === currentAnimal);

        clickedBtn = button;

        clickedBtn.classList.add('swiper-pagination-bullet-active');

        slider.querySelectorAll('[data-animal-section]').forEach((item) => {
          item.classList.remove('active');
          if (item.dataset.animalSection === currentAnimal) {
            item.classList.add('active');
            swiper_second.slideTo(indexSlide);
          }
        });
      }
    });
  });

  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
  const calibres = document.querySelectorAll(".calibre");

  if (isMobile) {
    document.addEventListener("click", function (event) {
      calibres.forEach(calibre => {
        const content = calibre.querySelector(".calibre__content");
        const label = calibre.querySelector(".calibre__label");

        if (calibre.contains(event.target) && !content.contains(event.target)) {
          content.classList.toggle("calibre__content--active");
          label.classList.toggle("calibre__label--active");
        } else if (!content.contains(event.target)) {
          content.classList.remove("calibre__content--active");
          label.classList.remove("calibre__label--active");
        }
      });
    });
  } else {
    calibres.forEach(calibre => {
      const content = calibre.querySelector(".calibre__content");
      const label = calibre.querySelector(".calibre__label");

      calibre.addEventListener("mouseenter", function () {
        content.classList.add("calibre__content--active");
        label.classList.add("calibre__label--active");
      });

      calibre.addEventListener("mouseleave", function () {
        content.classList.remove("calibre__content--active");
        label.classList.remove("calibre__label--active");
      });
    });
  }
});
